// Sudoku Solver - Validation and solving algorithms

if (window.__debug__) {
  console.debug("SudokuSolver loading...");
}

const SudokuSolver = {
  // Check if placing a number in a cell is valid
  isValid(board, row, col, num) {
    // Check row
    for (let x = 0; x < 9; x++) {
      if (board[row][x] === num) return false;
    }

    // Check column
    for (let x = 0; x < 9; x++) {
      if (board[x][col] === num) return false;
    }

    // Check 3x3 box
    const startRow = Math.floor(row / 3) * 3;
    const startCol = Math.floor(col / 3) * 3;
    for (let i = 0; i < 3; i++) {
      for (let j = 0; j < 3; j++) {
        if (board[startRow + i][startCol + j] === num) return false;
      }
    }

    return true;
  },

  // Find conflicts for a specific cell
  getConflicts(board, row, col) {
    const conflicts = [];
    const num = board[row][col];

    if (num === 0) return conflicts;

    // Check row
    for (let x = 0; x < 9; x++) {
      if (x !== col && board[row][x] === num) {
        conflicts.push({ row, col: x });
      }
    }

    // Check column
    for (let x = 0; x < 9; x++) {
      if (x !== row && board[x][col] === num) {
        conflicts.push({ row: x, col });
      }
    }

    // Check 3x3 box
    const startRow = Math.floor(row / 3) * 3;
    const startCol = Math.floor(col / 3) * 3;
    for (let i = 0; i < 3; i++) {
      for (let j = 0; j < 3; j++) {
        const r = startRow + i;
        const c = startCol + j;
        if ((r !== row || c !== col) && board[r][c] === num) {
          conflicts.push({ row: r, col: c });
        }
      }
    }

    return conflicts;
  },

  // Solve the puzzle using backtracking
  solve(board) {
    const find = this.findEmpty(board);
    if (!find) return true; // Puzzle solved

    const [row, col] = find;

    for (let num = 1; num <= 9; num++) {
      if (this.isValid(board, row, col, num)) {
        board[row][col] = num;

        if (this.solve(board)) return true;

        board[row][col] = 0;
      }
    }

    return false;
  },

  // Find an empty cell
  findEmpty(board) {
    for (let i = 0; i < 9; i++) {
      for (let j = 0; j < 9; j++) {
        if (board[i][j] === 0) return [i, j];
      }
    }
    return null;
  },

  // Check if puzzle is completely and correctly filled
  isComplete(board) {
    for (let i = 0; i < 9; i++) {
      for (let j = 0; j < 9; j++) {
        if (board[i][j] === 0) return false;

        // Create temp board to check validity
        const temp = board[i][j];
        board[i][j] = 0;
        if (!this.isValid(board, i, j, temp)) {
          board[i][j] = temp;
          return false;
        }
        board[i][j] = temp;
      }
    }
    return true;
  },

  // Deep copy a board
  copyBoard(board) {
    return board.map((row) => [...row]);
  },
};

window.SudokuSolver = SudokuSolver;

if (window.__debug__) {
  console.debug("SudokuSolver exported to window");
}
